module.exports = __webpack_public_path__ + "static/media/2-6.41853dc5.svg";